/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractStatus = {
  type: 'Enum',
} as const;
